<template>
  <div class="main-contract-fa">
    <el-tabs type="border-card" @tab-click="activeChange" v-model="activeName">
      <el-tab-pane label="创建合同" name="first">
        <createCT :btn_modify="false"></createCT>
      </el-tab-pane>
      <el-tab-pane label="审批合同" name="second">
        <sendCT></sendCT>
      </el-tab-pane>
      <el-tab-pane label="查看合同" name="third">
        <viewCT></viewCT>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import viewCT from "./components/viewCT.vue";
import createCT from "./components/createCT.vue";
import sendCT from "./components/sendCT.vue";
import {QueryContract} from "@/api/baseinfo.js"
export default {
  components: { createCT, sendCT, viewCT },
  created(){
    this.activeName = window.sessionStorage.getItem("tags_value");
  },
  data() {
    return {
      activeName: "first"
    };
  },
  
  provide(){
    return{
      QueryContract:this.QueryContract
    }
  },
  methods: {
    activeChange(e){
    window.sessionStorage.setItem("tags_value",e.name);
  },
    async QueryContract() {
      return await QueryContract("","","*");
    }
  }
};
</script>
<style scoped>
.main-contract-fa .el-tabs {
  width: 98%;
  height: 600px;
  margin: 1% 1%;
  color: rgb(105, 105, 105);
}
.el-tabs {
  height: 100% !important;
}
</style>
